































import { defineComponent, PropType, nextTick, ref, onUpdated } from '@nuxtjs/composition-api';
import ProductCard from 'components/catalog/Product/ProductCard.vue';
import { useImage } from '@wemade-vsf/composables';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { usePageStore } from '@wemade-vsf/core';
import { useScrollPositionStore } from '~/stores/scrollPosition';
import { storeToRefs } from 'pinia';

import SkeletonLoader from 'components/theme/SkeletonLoader.vue';

export default defineComponent({
  components: {
    ProductCard,
    SkeletonLoader,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup() {
    const { imageSizes: { productCard: imageSize } } = useImage();
    const { routeData } = usePageStore();
    const scrollPositionStore = useScrollPositionStore();
    const { lastRoute } = storeToRefs(scrollPositionStore);
    const scrolled = ref(false);

    const scrollToPosition = () => {
      if (!process.browser || scrolled.value) return;
      if (lastRoute.value === routeData.uid) {
        const scroll = scrollPositionStore.getScrollPosition(routeData.uid);
        window.scrollTo(0, scroll);
      }
      scrolled.value = true;
      lastRoute.value = routeData.uid;
    }

    function storeScrollPosition() {
      if (!routeData?.uid) return;
      scrollPositionStore.setScrollPosition(routeData.uid, window.scrollY);
    }

    onUpdated(() => {
      nextTick(() => {
        scrollToPosition();
      });
    })

    return {
      imageSize,
      storeScrollPosition
    };
  },
});
